import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAdvertisementComponent } from './create-advertisement.component';

const routes: Routes = [
  {
    path: '', component: CreateAdvertisementComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateAdvertisementRoutingModule { }
